
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/admin/bank-accounts",
      function () {
        return require("private-next-pages/admin/bank-accounts/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/admin/bank-accounts"])
      });
    }
  